import React from 'react';
import { InputLabel, FormControl, Select, MenuItem } from '@material-ui/core';
import { DeviceFirmwareReleaseType } from '../models/device';
import { useTranslation } from 'react-i18next';

interface DeviceFirmwareTypeSelectProps {
  value: string;
  onChange: (value: string) => void;
  cssClass?: string;
  fullWidth?: boolean;
}

const DeviceFirmwareReleaseTypeSelect = ({ value, onChange, cssClass, fullWidth }: DeviceFirmwareTypeSelectProps) => {
  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const value = event.target.value as string;

    //callback
    onChange && onChange(value);
  };

  const { t } = useTranslation();

  return (
    <FormControl className={cssClass} fullWidth={fullWidth} size="small">
      <InputLabel id="firmwareReleaseTypeLabel">{t('f-device-release-type')}</InputLabel>
      <Select labelId="firmwareReleaseTypeLabel" id="firmwareReleaseTypeSelect" value={value} onChange={handleChange}>
        <MenuItem value={''} id="type-any">
          {t('f-any')}
        </MenuItem>

        <MenuItem value={DeviceFirmwareReleaseType.Release} id="type-r">
          {'Release'}
        </MenuItem>

        <MenuItem value={DeviceFirmwareReleaseType.Debug} id="type-d">
          {'Debug'}
        </MenuItem>

        <MenuItem value={DeviceFirmwareReleaseType.Testing} id="type-t">
          {'Testing'}
        </MenuItem>
      </Select>
    </FormControl>
  );
};

export default DeviceFirmwareReleaseTypeSelect;
